<template>
  <div class="card-skeleton">
    <SkeletonItem
      class="img"
      :animated="true"
    />
    <SkeletonItem
      class="title"
      :animated="true"
    />
    <SkeletonItem
      class="address"
      :animated="true"
    />
    <div class="subtitle-block">
      <SkeletonItem
        v-for="i in 4"
        :key="i"
        :class="`subtitle subtitle-${i}`"
        :animated="true"
      />
    </div>
    <div class="btns">
      <SkeletonItem
        class="btn-skeleton"
        :animated="true"
      />
      <SkeletonItem
        class="btn-skeleton"
        :animated="true"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style lang="scss" scoped>
  @use 'sass:math';

  * {
    border-radius: var(--alias-radius-8, 8px);
  }

  .img {
    width: 100%;
    aspect-ratio: 4 / 3;
  }

  .title {
    width: 70%;
    height: 24px;
    margin-top: var(--alias-space-8);
  }

  .address {
    width: 50%;
    height: 16px;
    margin-top: var(--alias-space-4);
  }

  .subtitle-block {
    display: grid;
    gap: 4px;
    margin-top: var(--alias-space-12);
  }

  .subtitle {
    height: 16px;
  }

  .btns {
    display: flex;
    gap: 8px;
    margin-top: var(--alias-space-12);
  }

  .btn-skeleton {
    width: 100%;
    height: 48px;
  }

  @function random-num($min, $max) {
    $rand: math.random();
    $random-num: $min + math.floor($rand * (($max - $min) + 1));

    @return $random-num;
  }

  @for $i from 1 through 4 {
    .subtitle-#{$i} {
      width: #{random-num(40, 100)}%;
    }
  }
</style>
